import { render, staticRenderFns } from "./Menus.vue?vue&type=template&id=069977dc"
import script from "./Menus.vue?vue&type=script&lang=js"
export * from "./Menus.vue?vue&type=script&lang=js"
import style0 from "./Menus.vue?vue&type=style&index=0&id=069977dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports